import { z } from 'zod'
import { t } from 'i18next'
import {
  EtcsBetriebsartSchema,
  EtcsLevelSchema
} from '../../Generic/schema/generic.schema'

// Default constants
const DEFAULT_AUFTRAG_28_10 = {
  enabled: false,
  etcsLevel: ''
}

const DEFAULT_AUFTRAG_28_20 = {
  enabled: false,
  etcsBetriebsart: ''
}

const DEFAULT_BEFEHL_28_FORM = {
  auftrag_28_10: DEFAULT_AUFTRAG_28_10,
  auftrag_28_20: DEFAULT_AUFTRAG_28_20
}

// Schema definitions
export const Auftrag28_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_28_10.enabled),
    etcsLevel: EtcsLevelSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_28_10))

export const Auftrag28_20Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_28_20.enabled),
    etcsBetriebsart: EtcsBetriebsartSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_28_20))

// Base schema
const Befehl28FormSchemaBase = z
  .object({
    auftrag_28_10: Auftrag28_10Schema,
    auftrag_28_20: Auftrag28_20Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_28_FORM))

export const Befehl28FormSchema = Befehl28FormSchemaBase

// Validation schema
export const createBefehl28FormValidationSchema = () =>
  Befehl28FormSchemaBase.refine(
    (data) => {
      return data.auftrag_28_10.enabled || data.auftrag_28_20.enabled
    },
    {
      message: t('ui-validation:befehl28.at_least_one')
    }
  )

export type Befehl28FormData = z.infer<typeof Befehl28FormSchemaBase>
